import React from 'react'
import PropTypes from 'prop-types'

import { ContentWrapper } from '../shared/content-wrapper'
import CtaButton from '../buttons/cta-button'
//import Icon from '../icons/icon'
import HeadingGamma from '../headings/heading-gamma'
import HeadingDelta from '../headings/heading-delta'
import SignForm from '../shared/sign-form'
import InputField from '../forms/input-field'
import Notification, { StatusTypes } from '../notifications/notification'

const ForgetPassword = props => (
  <ContentWrapper>
    <SignForm>
      {/*<div className='prominent-icon'>
        <Icon name='warning' />
      </div>*/}
      <HeadingGamma>Reset your password</HeadingGamma>
      {props.isSuccess ? (
        <HeadingDelta thin>
          An email has been sent to you with instructions on how to reset your
          password.
        </HeadingDelta>
      ) : (
        <div>
          <HeadingDelta thin>
            Enter your email address and we'll send you reset instructions.
          </HeadingDelta>
          <form>
            <InputField
              label='Email address'
              theme='dark-theme'
              value={props.email}
              onChange={props.onEmailChange}
              autoFocus
            />
            {props.isError && (
              <Notification
                status={StatusTypes.ERROR}
                title='Something failed, try again later'
              />
            )}
            <div className='top-space bottom-space'>
              <CtaButton
                text='Reset my password'
                iconName='delivery'
                onClick={props.onSendInstructionsClick}
                isLoading={props.isSending}
                disabled={props.isSending || props.isLinkSent}
              />
            </div>
          </form>
        </div>
      )}
    </SignForm>
  </ContentWrapper>
)

ForgetPassword.propTypes = {
  // injected by decorator
  email: PropTypes.string,
  onEmailChange: PropTypes.func,
  onSendInstructionsClick: PropTypes.func,
  isSending: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string
}

export default ForgetPassword



// WEBPACK FOOTER //
// ./src/ui/forget-password/ForgetPassword.js